import { UserOptionLabel } from "components/autocompleteOptions/merchantOptionLabel";
import { getFullName } from "helpers";
import { applicationListService } from "services";
import { FilterColumn } from "types";

const assignedToColumn = ({
	name = "assignedTo",
	placeholder = "Assigned To",
} = {}): FilterColumn => ({
	name,
	type: "select" as const,
	placeholder,
	formatLabel: getFullName,
	getOptionLabel: UserOptionLabel,
	getOptionValue: option => option.id,
	loadOptions: async (search, prevOptions, { page }) => {
		try {
			const showInactive = true;
			let newUsers = await applicationListService.getAssignedUsers(
				search,
				page,
				showInactive,
			);
			const hasMore =
				prevOptions.length + newUsers.items.length < newUsers.count;

			return {
				options: newUsers.items,
				hasMore,
				additional: {
					page: page + 1,
				},
			};
		} catch {
			return { options: [] };
		}
	},
});

export default assignedToColumn;
